export enum DocumentStatus {
  Draft = 'Draft for review',
  RMReviewed = 'RM Reviewed',
  SelfReviewed = 'Self-reviewed',
  FinalArchiveReadyVersion = 'Final - Archive ready version',
  SupportingDocument = 'Supporting documentation - no review required',
  InternalRMReviewed = 'Internal RM Reviewed',
  AdditionalRMReviewRequired = 'Additional RM review required',
}

export const IntakeDocumentStatusIdMapper = new Map<DocumentStatus, number>([
  [DocumentStatus.Draft, 1],
  [DocumentStatus.RMReviewed, 2],
  [DocumentStatus.FinalArchiveReadyVersion, 3],
  [DocumentStatus.SelfReviewed, 4],
  [DocumentStatus.SupportingDocument, 5],
  [DocumentStatus.InternalRMReviewed, 6],
  [DocumentStatus.AdditionalRMReviewRequired, 7],
]);

export enum DocumentArchivalStatus {
  ARCHIVED = 'Archived',
  MOVED = 'Archived',
  PENDING = 'Pending',
}

export const draftDocStatus: string[] = [
  DocumentStatus.Draft,
  DocumentStatus.SupportingDocument,
];

export const resubmitDraftDocStatus: string[] = [DocumentStatus.Draft];

export const reviewedDocStatus: string[] = [
  DocumentStatus.RMReviewed,
  DocumentStatus.FinalArchiveReadyVersion,
];

export const archiveDocStatus: string[] = [
  DocumentStatus.FinalArchiveReadyVersion,
];
